import { useRouter } from 'next/router';

import { ChevronLeft } from '@/icons';
import { IconButton } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeGoBackProps } from './types';

/**
 * GoBack
 */
export const GoBack: FunctionComponent<TypeGoBackProps> = ({
  className = '',
  children,
}: TypeGoBackProps) => {
  const router = useRouter();

  return (
    <div
      className={`relative flex flex-row items-center justify-center gap-6 bg-bg-tertiary px-4 py-2 text-typo-alternative ${className}`}
    >
      <span className="u-headline u-headline--h2">{children}</span>
      <IconButton
        style="outline"
        size="small"
        className="absolute left-3"
        onClick={() => router.back()}
      >
        <ChevronLeft />
      </IconButton>
    </div>
  );
};
